import React from "react";
import { Tag } from "antd";

const STATUS_CONFIG = {
  PAID: { color: "green", text: "PAID" },
  UNPAID: { color: "orange", text: "UNPAID" },
  OVERDUE: { color: "volcano", text: "OVERDUE" },
  SETTLED: { color: "geekblue", text: "SETTLED" },
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    color: "default",
    text: status || "—",
  };
  return <Tag color={config.color}>{config.text}</Tag>;
};

export default StatusBadge;
